import React from "react"
import { Card, Input, Switch, Space, Typography, Divider, Row, Col } from "antd"
import { SettingOutlined } from "@ant-design/icons"

const { Title, Text } = Typography
const { TextArea } = Input

const AdminControlPanel = ({
  inactiveDes,
  setInactiveDes,
  clientSetting,
  onInactiveClient,
  clientLoading,
}) => {
  return (
    <Card
      title={
        <Space>
          <SettingOutlined />
          <Title level={5} style={{ margin: 0 }}>
            پنل کنترل مدیریت
          </Title>
        </Space>
      }
      bordered={true}
      style={{ borderRadius: "8px" }}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="large">
        <div>
          <Text strong>غیر فعال کردن پیش ثبت نام پرونده در سامانه</Text>
          <Divider style={{ margin: "12px 0" }} />
          <Row gutter={16} align="middle">
            <Col xs={24} md={18}>
              <TextArea
                value={inactiveDes}
                rows={3}
                onChange={e => setInactiveDes(e.target.value)}
                placeholder="توضیحات غیرفعال‌سازی را وارد کنید..."
                style={{ width: "100%" }}
              />
            </Col>
            <Col xs={24} md={6}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Text type="secondary">وضعیت سامانه:</Text>
                <Switch
                  checked={clientSetting?.inactive}
                  onChange={() => onInactiveClient(inactiveDes)}
                  loading={clientLoading}
                  checkedChildren="غیر فعال"
                  unCheckedChildren="فعال"
                  style={{ width: "100%" }}
                />
              </Space>
            </Col>
          </Row>
        </div>
      </Space>
    </Card>
  )
}

export default AdminControlPanel
